import React, { PureComponent } from 'react';
import {
  PieChart, Pie, Sector, Cell, Tooltip,
} from 'recharts';


const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({
  cx, cy, midAngle, innerRadius, outerRadius, percent, index,
}) => {
   const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};

export default class PieGraph extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      data: [],
      key : 1
    }
  }

  componentWillReceiveProps(nextProps) {
    const oldData = this.state.data
    const newData = nextProps.data
    let changed = false
    newData.map((newDataEntry, i) => {
      if(!oldData[i] || newDataEntry.value != oldData[i].value) changed = true
    })
    if(changed) {
      this.setState({data: nextProps.data, key: this.state.key+1})
    }
  }

  render() {
    return (
      <PieChart width={260} height={200}>
        <Pie
          data={this.state.data}
          key={this.state.key}
          cx={130}
          cy={75}
          labelLine={false}
          label={renderCustomizedLabel}
          outerRadius={60}
          fill="#8884d8"
          dataKey="value"
        >

        </Pie>
        <Tooltip />
      </PieChart>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/user/pie.jsx